<template>
  <b-card no-body>
    <div
      v-if="attachments.length === 0"
      class="ml-2"
    >
      <span class="font-weight-bold">{{ $t('attachments.no-attachments') }}</span>
    </div>

    <b-row
      v-for="(a, index) in attachments"
      :key="index"
      class="mb-1 ml-1"
    >
      <div class="d-flex align-items-center">
        <b-avatar
          variant="light-secondary"
          rounded
        >
          <feather-icon
            :icon="`${resolveFileIcon(a.filename)}Icon`"
            size="18"
          />
        </b-avatar>
        <div class="ml-1">
          <b-link
            class="font-weight-bold d-block text-nowrap"
            @click="download(a)"
          >
            {{ a.filename }}
          </b-link>
          <small>{{ formatFileType(a.filename) }} ({{ formatBytes(a.size, 1) }}) - {{ formatDateHumanFriendly(a.lastUpdate) }}</small>
        </div>
      </div>
    </b-row>

    <b-modal
      ref="modalPreview"
      :title="imgFilename"
      centered
      hide-footer
      size="lg"
    >
      <b-link
        :href="imgSource"
        :download="imgFilename"
      >
        <b-img
          center
          :src="imgSource"
          fluid
        />
      </b-link>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BRow, BAvatar, BCard, BLink, BImg, VBModal, BModal,
} from 'bootstrap-vue'
import axios from '@axios'
import { ref } from '@vue/composition-api'
import {
  formatFileType, resolveFileIcon, formatBytes, formatDateHumanFriendly, getResponseFilename, download,
} from '@/views/layouts/layouts.utils'

export default {
  components: {
    BRow, BAvatar, BCard, BLink, BImg, BModal,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    value: {
      type: Array,
      default: null,
    },
    // eslint-disable-next-line vue/require-prop-types
    refaid: {
      required: true,
    },
  },
  data() {
    return {
      imgSource: null,
      imgFilename: null,
    }
  },
  computed: {
    uuids: {
      get() { return this.value },
      set(value) { this.$emit('input', value) },
    },
  },
  mounted() {
    this.refetchData()
    this.$watch('uuids', () => {
      this.refetchData()
    }, { deep: true })
  },
  methods: {
    async download(attachment) {
      const response = await axios.get('/api/storage', {
        params: { aid: this.refaid, fid: attachment.fid },
        responseType: 'blob',
      })
      const filename = getResponseFilename(response)
      const extension = filename.split('.').pop().toLowerCase()
      if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
        const blob = new Blob([response.data], { type: response.data.type })
        const url = URL.createObjectURL(blob)
        this.imgSource = url
        this.imgFilename = filename
        this.$refs.modalPreview.show()
      } else { download(response) }
    },
    async refetchData() {
      if (this.uuids) {
        const response = await axios.post('/api/storage', { aid: this.refaid, fids: this.uuids })
        this.attachments = response.data
      }
    },
  },
  setup() {
    const attachments = ref([])
    return {
      attachments,
      formatFileType,
      formatBytes,
      formatDateHumanFriendly,
      resolveFileIcon,
    }
  },
}
</script>
